import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

const MODULES = [
  {
    name: 'Módulo 1 - Introdução, cronograma e dados iniciais',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Introdução [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/jUjhPgKi7Ao'
      },
      {
        title: 'Cronograma - Ciclo 1 [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/My-qMR4Dduc'
      },
      {
        title: 'Dados Iniciais - Ciclo 1 [aula 3]',
        youtubeLink: 'https://www.youtube.com/embed/MDKa6do8fmY'
      }
    ]
  },
  {
    name: 'Módulo 2 - Objetivos: geral e específicos e justificativa',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Objetivos: geral e específicos - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/1W7vn6HFf3s'
      },
      {
        title: 'Justificativa - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/GkHNKpllCRs'
      }
    ]
  },
  {
    name: 'Módulo 3 - Hipóteses e critérios de seleção',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Hipóteses - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/aGvy4R4o28s'
      },
      {
        title: 'Critérios de Seleção - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/NENQVdZ2LjU'
      }
    ]
  },
  {
    name: 'Módulo 4 - Cadastro, menu, perfil, pastas e projetos',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Cadastro, Menu, Perfil, Pasta e Projetos - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/K1tNfkS8sxc'
      }
    ]
  },
  {
    name: 'Módulo 5 - Prática cronograma e dados iniciais',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Prática - Cronograma - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/wHbUmj2YieI'
      },
      {
        title: 'Prática - Dados iniciais - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/bY1TBCNNWxM'
      }
    ]
  },
  {
    name: 'Módulo 6 - Avaliação metodológica e extração de dados',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Avaliação metodológica - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/_t6mIUjCEIg'
      },
      {
        title: 'Extração de dados - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/ZRoaQgA2spQ'
      }
    ]
  },
  {
    name: 'Módulo 7 - Pesquisa (adic. String), importar e selecionar estudos',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Pesquisa (Adicionar String) - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/KM2LAM4mu3k'
      },
      {
        title: 'Importar os estudos - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/C6LiAQYZ72Y'
      },
      {
        title: 'Selecionar estudos - [aula 3]',
        youtubeLink: 'https://www.youtube.com/embed/PHKLNyJ5qVg'
      }
    ]
  },
  {
    name: 'Módulo 8 - Fichamento',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Fichamento - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/bIV3QQIB9fw'
      },
    ]
  },
  {
    name: 'Módulo 9 - Variáveis teóricas, operacionais, níveis de variáveis, independente e dependente',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Variáveis teóricas, operacionais e níveis de variáveis - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/8EzmjzsBbcg'
      },
      {
        title: 'Variáveis independentes e dependentes - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/fJqLEijtY4k'
      },
    ]
  },
  {
    name: 'Módulo 10 - Variáveis necessárias e suficientes, pesquisa descritiva, pesq. de associação SEM e COM interferência e estratégia da pesquisa',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Necessárias e suficientes - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/SNVC7nNND-k'
      },
      {
        title: 'Pesquisa descritiva - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/wBKVAyTy5LI'
      },
      {
        title: 'Pesquisa de associação SEM interferência entre variáveis - [aula 3]',
        youtubeLink: 'https://www.youtube.com/embed/UAar0VJ00co'
      },
      {
        title: 'Pesquisa de associação COM interferência entre variáveis - [aula 4]',
        youtubeLink: 'https://www.youtube.com/embed/fyI1JUdg3ok'
      },
      {
        title: 'Estratégia da pesquisa - [aula 5]',
        youtubeLink: 'https://www.youtube.com/embed/acvJvxNAB5U'
      },
    ]
  },
  {
    name: 'Módulo 11 - Leitura, escrita, unidade de texto e parágrafo',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Leitura, escrita, unidade de texto e parágrafo - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/hepCFq8wKPc'
      },
    ]
  },
  {
    name: 'Módulo 12 - Planejamento da escrita, revisão da literatura, coesão e coerência, tópicos frasais, nominalizações e conjunções',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Planejamento da escrita - Revisão da Literatura - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/gLC0wedLIqg'
      },
      {
        title: 'Coesão e coerência - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/sP4Z0sN5RlM'
      },
      {
        title: 'Tópicos frasais - [aula 3]',
        youtubeLink: 'https://www.youtube.com/embed/WK3Y_98zPvg'
      },
      {
        title: 'Nominalizações e conjunções - [aula 4]',
        youtubeLink: 'https://www.youtube.com/embed/H8ooxuQrjd8'
      },
    ]
  },
  {
    name: 'Módulo 13 - Uso da voz ativa e passiva, seja sintético e evite proxilidade',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Uso da voz ativa e passiva, seja sintético e evite prolixidade - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/kUPRIrqQtug'
      },
    ]
  },
  {
    name: 'Módulo 14 - Tipos de citações e referências',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Tipos de citações e referência - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/i5leegf3zxs'
      },
    ]
  },
  {
    name: 'Módulo 15 - Bibliometria',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Bibliometria',
        youtubeLink: 'https://www.youtube.com/embed/pQRlW7t7fzQ'
      },
    ]
  },
  {
    name: 'Módulo 16 - Análise dos estudos e revisão da literatura',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Análise dos estudos - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/7pw_ENrCnj0'
      },
      {
        title: 'Revisão da Literatura - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/jnq8DpY3KOc'
      },
    ]
  },
  {
    name: 'Módulo 17 - Configuração - Ciclo 3',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Configuração Ciclo 3 - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/ft8jtCnTrWU'
      },
    ]
  },
  {
    name: 'Módulo 18 - Conhecendo os recursos do editor – Ciclo 4',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: [
      {
        title: 'Visualizando as opções do editor - [aula 1]',
        youtubeLink: 'https://www.youtube.com/embed/7WukTtWiIS4'
      },
      {
        title: 'Seção - [aula 2]',
        youtubeLink: 'https://www.youtube.com/embed/kRi8uXZGBUY'
      },
      {
        title: 'Folha de rosto - [aula 3]',
        youtubeLink: 'https://www.youtube.com/embed/eF0mEtntg_8'
      },
      {
        title: 'Ficha catalográfica - [aula 4]',
        youtubeLink: 'https://www.youtube.com/embed/-nEj4UuttW4'
      },
      {
        title: 'Folha de aprovação - [aula 5]',
        youtubeLink: 'https://www.youtube.com/embed/miXyCMGA9gI'
      },
      {
        title: 'Dedicatória e agradecimentos - [aula 6]',
        youtubeLink: 'https://www.youtube.com/embed/s9v6bEfXPT0'
      },
      {
        title: 'Epígrafe - [aula 7]',
        youtubeLink: 'https://www.youtube.com/embed/lrUEjiVrY0M'
      },
      {
        title: 'Resumo e Abstract - [aula 8]',
        youtubeLink: 'https://www.youtube.com/embed/kadVV9nCg4w'
      },
      {
        title: 'Lista de tabelas e ilustrações (auto) - [aula 9]',
        youtubeLink: 'https://www.youtube.com/embed/QKZUo3LwN9c'
      },
      {
        title: 'Lista de abrev. e siglas - [aula 10]',
        youtubeLink: 'https://www.youtube.com/embed/sQiPa9OA10w'
      },
      {
        title: 'Lista de símbolos - [aula 11]',
        youtubeLink: 'https://www.youtube.com/embed/vzwAdvL20dY'
      },
      {
        title: 'Apêndices e anexos - [aula 12]',
        youtubeLink: 'https://www.youtube.com/embed/kyi6wbq1gUs'
      }
    ]
  },
  {
    name: 'Módulo 19 - Estrutura das seções',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: []
  },
  {
    name: 'Módulo 20 - Visão geral da produção científica',
    leftColumnTop: 'O que vamos aprender?',
    leftColumnBottom: 'Vamos começar!',
    rightColumnTop: '',
    lessons: []
  }
];

@Component({
  selector: 'app-basic-of-metodology',
  templateUrl: './basic-of-metodology.component.html',
  styleUrls: ['./basic-of-metodology.component.scss']
})
export class BasicOfMetodologyComponent implements OnInit {
  public modules = [];

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.modules = MODULES.map(module => {
      return {
        ...module,
        lessons: module.lessons.map(lesson => ({
          ...lesson,
          youtubeLink: lesson.youtubeLink.length ? this.sanitizer.bypassSecurityTrustResourceUrl(lesson.youtubeLink) : null
        }))
      }
    });
  }
}
